/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerClass()
    export class IcStockApproveDtEditor extends Serenity.Extensions.GridEditorBase<IcStockApproveDtRow> {
        protected getColumnsKey() { return "Inventory.IcStockApproveDt"; }
        protected getDialogType() { return IcStockApproveDtDialog; }
        protected getLocalTextPrefix() { return IcStockApproveDtRow.localTextPrefix; }

        public qnNo: number;
        


        public myPassValue: string;
        
        constructor(container: JQuery) {
            super(container);
        
        }      

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();
            //let self = this;
            //self.toolbar.findButton('add-button').text('สร้างรายการ');
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            return buttons;
        }   
        public DisableAddButton() {
            this.toolbar.findButton('add-button').toggleClass('disabled', true);
            Serenity.EditorUtils.setReadonly(this.element.find('.editor'), true);
        }
        
        
       protected createSlickGrid() {
        var grid = super.createSlickGrid();

        // need to register this plugin for grouping or you'll have errors
        grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

        this.view.setSummaryOptions({
            aggregators: [
                new Slick.Aggregators.Sum('QtyCount'),
                new Slick.Aggregators.Sum('QtyOnhand'),
                new Slick.Aggregators.Sum('QtyDif'),
                new Slick.Aggregators.Sum('CostValue')
            ]
        });
        return grid;
    }

    protected getSlickOptions() {
        var opt = super.getSlickOptions();
        opt.showFooterRow = true;
        // opt.frozenColumn = 1;
        return opt;
    }

    protected usePager() {
        return false;
    }

    }
}

